import React from 'react';
import EditDisplayForm from '@/components/displays/edit/EditDisplayForm';

const EditDisplay: React.FC = () => {
  return <EditDisplayForm />;
};

export default EditDisplay;